<template>
  <div class="d-flex justify-content-center align-items-center dashboard">
		<div class="dashboard__complete">
			<div class="row">
				<div class="col-12 text-center">
					<h1>Em Construção</h1>
				</div>
			</div>
		</div>
  </div>
</template>

<script>
  /* eslint-disable */
  export default {
     data() {
       return {
        
       }
		
   }
  }
</script>



// WEBPACK FOOTER //
// src/views/EmConstrucao.vue